import tplLoader from "./tpl-loader.js";
import functions from './functions.js';
import Slider from "./Slider";
import calendar from  './calendar.js';
import {SimpleGuests} from "./simple-guests.js";

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '2,0', 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    specialDiscounts: [],
    showMonths: {
        'xxl': 4,
        'xl': 4,
        'lg': 3,
        'md': 2,
        'sm': 1,
        'xs': 1
    },
    inquiryRequired: ['dates', 'firstName', 'lastName', 'email', 'phone', 'guests'],
    focusOnBooking: false,
    calcTotal: 0,
    trackingTotal: 0,
    init() {
        
        if(! $('.page-type-details')[0]) {
            return;
        }
        let isMobile = functions.isMobile();
        
        if (isMobile)
        {
            $('.nav-bottom').addClass('visible');
            
            $('.btn-select-date').on('click', function() {
                setTimeout(() => {
                    $('.contact-select-mobile').addClass('d-none');
                    $('.show-on-calendar').removeClass('d-none');
                }, 300);
            });
            
            $('.book-now-nav-bottom').on('click', function() {
                let wh = $(window).outerHeight();
                functions.scrollToElement($('.booking-scroll-hook'), wh);
            });
           

            $(window).scroll(e => {
    
                var elementTop = $('.details-guests').offset().top;
                var elementBottom = elementTop + $('.details-guests').outerHeight();

                var bookTop = $('.btn-request').offset().top;
                var bookBottom = bookTop + $('.btn-request').outerHeight();
                var offset = bookBottom - elementBottom + 5;

                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                if (elementBottom > viewportTop - offset && elementTop < viewportBottom)
                {
                    if (details.datesSelected()) $('.nav-bottom').removeClass('visible');
                    $('.contact-select-mobile').addClass('d-none');
                    $('.show-on-calendar').removeClass('d-none');
                    
                }
                else 
                {     
                    $('.nav-bottom').addClass('visible');
                    $('.contact-select-mobile').removeClass('d-none');
                    $('.show-on-calendar').addClass('d-none'); 
                }
                
    
            });

        }
        $(window).scroll(e => {
            const offset = $('#booking').offset().top - $('#booking').outerHeight();

            $(window).scrollTop() > 200 
                ? $('.nav-top').addClass('visible') 
                : $('.nav-top').removeClass('visible');
            
            if (! isMobile)
            {
                $(window).scrollTop() > 550 && $(window).scrollTop() < offset
                ? $('.nav-bottom').addClass('visible') 
                : $('.nav-bottom').removeClass('visible');
            }

        });

        new Slider('#details-gallery-slider', {
            rubberband: false,
            loop: true,
            arrows: true,
            slides: {
                perView: 1,
                spacing: 4
            },
            duration: 1000,
            //autoplay: 3000,
            autoplay: 0,
            pauseOnHover: true,
            pager: true,
            breakpoints: {
                '(max-width: 1000px)': {
                    slides: {
                        perView: 1
                    },
                },
            },
            autoLoadSlides: 3,
        });

        details.getParams();

        if (isMobile && details.datesSelected())
        {
            $('.select-dates-nav-bottom').addClass('d-none');
            $('.book-now-nav-bottom').removeClass('d-none');
        }

        // if(details.params.calendar) functions.scrollToElement($('#booking'), 0);

        // let params = functions.getUrlData(true);
        // details.params.guests = params.guests;

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.unitId = $('#booking').attr('data-unitid');

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if($('[data-calendarconfig]')[0]) {
            details.calendarInit();

            details.specialDiscounts = $('[data-calendarconfig]').attr('data-specialDiscounts') ? JSON.parse($('[data-calendarconfig]').attr('data-specialDiscounts')) : [];
        }

        if(details.params.dateFrom && details.params.dateTo) {
            if($('[name="dates"]')[0]._flatpickr) {

                $('[name="dates"]')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            }
           details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        }

        if(details.params.guests && $('.simple-guests')[0]) {
            $('.simple-guests').each( (index, elem) => {
                elem._simpleGuests.setValue(details.params.guests);
            });
        }

        details.getCalculation();


        $('[name="dates"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.splitCalendarDates($target.val());
            if (details.params.dateFrom && details.params.dateTo) 
            {
                details.focusOnBooking = true;
                $('.nav-bottom').removeClass('visible');
                $('.select-dates-nav-bottom').addClass('d-none');
                $('.book-now-nav-bottom').removeClass('d-none');
            }
            functions.setUrlData(details.params, true, true);
        });

        $('.btn-clear-dates').on('click', function (e) {
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true, true);
            $('.total-converted').addClass('d-none');
            $('.total-converted-default').removeClass('d-none');
            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
            let priceWeek = $('.price-week-placeholder').html();
            if (functions.isMobile())
            {
                $('.nav-bottom').addClass('visible');
            }
            else 
            {
                $('.from-label').removeClass('d-none');
            }
            $('.select-dates-nav-bottom').removeClass('d-none');
            $('.book-now-nav-bottom').addClass('d-none');
            $('.price-per-week-label, .price-per-week').removeClass('d-none');
            $('.total-label').addClass('d-none');
            $('.init-price').removeClass('d-none');
            $('.old-init').removeClass('d-none');

            if (!$('[data-minPriceHasDiscount]').attr('data-minPriceHasDiscount')) 
            {
                $('.old-init').parent().addClass('d-none');
            }
            
            $('.total').addClass('d-none');
            $('.total-old').addClass('d-none');
            $('.details-night, .details-guests-num').addClass('d-none');
        });

        $('[name="guests"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.guests = $target.val();
            functions.setUrlData(details.params, true, true);
        });

        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });
        
        details.loadReviews();
        details.inquiryInit();



        let trackingData = JSON.parse($('[data-gatracking]').attr('data-gatracking'));
        if (trackingData)
        {
            functions.pushTrackingData(trackingData);
        }


    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);

            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.addClass('d-none');
                    }
                    $(".reviews").append(response.html);
                }
            });
        });
    },
    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        let defaultDate = $('[data-calendarconfig][data-defaultdate]').attr('data-defaultdate');
        let minDate = $('[data-calendarconfig]').attr('data-mindate');
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/
        details.$calendar = $('.datepicker-range-book')
        calendar.calendar.init(
            details.$calendar,
            {
                availabilityMask : config.availabilityMask,
                startDate : config.startDate,
                minStay : config.minStay,
                periods : config.periods,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate ? minDate : 'today',
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar mx-auto',
                showMonths: details.showMonths[functions.getBreakpoint()]
            },
            details.callbackOnDatesSelected
        );

        $('html').on('breakpointChanged', (e, {breakpoint}) => {
            details.$calendar[0]._flatpickr.set('showMonths', details.showMonths[breakpoint]);
        })
    },
    inquiryInit() {
        $('form#inquiry').find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').focusout( function(e) {
            let $elem = $(this);
            let valid = true;
            
            if ($elem.attr('name') == 'email')
            {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                valid = regex.test($elem.val());
            }

            if ($elem.hasClass('request-dates'))
            {
                $elem = $('#request-dates');
            }

            if ( ! ($elem.val() && valid)) 
            {
                // validForm = false;
                $elem.addClass('input-empty');
                $elem.siblings('.invalid-feedback').addClass('d-block');
            }
            else
            {
                $elem.removeClass('input-empty');
                $elem.siblings('.invalid-feedback').removeClass('d-block');
            }
        })
        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $(e.currentTarget).serializeArray();
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });
            let validForm = true;
            $('form#inquiry').find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').each( function(e) {
                let $elem = $(this);
                let valid = true;
                // if ($elem.attr('name') ==)
                if ($elem.attr('name') == 'email')
                {
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    valid = regex.test($elem.val());
                }
    
                if ( ! ($elem.val() && valid)) 
                {
                    validForm = false;
                    $elem.addClass('input-empty');
                    $elem.siblings('.invalid-feedback').addClass('d-block');
                }
                else
                {
                    $elem.removeClass('input-empty');
                    $elem.siblings('.invalid-feedback').removeClass('d-block');
                }
            })
            if (! validForm)
            {   
                $('.contact-btn').removeClass('d-none');
                $('.contact-spinner').addClass('d-none');
                $('.contact-spinner').removeClass('d-flex');
                return;
            }
            
            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfphqggAAAAAAsli7qz4-HH3vF2YCh-KLYX4qPT', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {
                        $("#inquiry").addClass('d-none');
                        response.status ? $('.request-success').removeClass('d-none') : $('.request-error').removeClass('d-none');
                        setTimeout(() => {
                            $('.request-modal-close').click();
                            $('.contact-btn').removeClass('d-none');
                            $('.contact-spinner').addClass('d-none');
                            $('.contact-spinner').removeClass('d-flex');
                            $("#inquiry").removeClass('d-none');
                            $(".request-error, .request-success").addClass('d-none');
                        }, 7000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }


                    });
                });
            });
        });
    },
    callbackOnDatesSelected(from, to) {

        if ( to && ! to[1]) {
            $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : ! from ? 'selectDates' : 'selectDepartureDate'}));
            $('.btn-booking').addClass('disabled');
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    isRequest(data) {
        return ! data.isAvailable && data.calc.status == 'Request';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    datesSelected()
    {
        return details.params.dateFrom && details.params.dateTo;
    },
    getCalculation(unitId = null) {


        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;
        
        if(
            (details.params.objectId || unitId)
            && details.params.guests 
            && dateFrom 
            && dateTo 
            && details.params.objectGroupId
        ) {

            $('.calc-loader').prepend(tplLoader).scrollTop(0);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang() 
                + '&addAllOptionals=' + 1
            )
            .done(response => {

                if(response.status) {
                    const data = response.data || [];

                    Object.entries(data).forEach(unit => {
                        const unitId = unit[0];
                        const unitData = unit[1];

                        const $btnBooking = $('.btn-booking');
                        if(details.isBookable(unitData)) {
                            const unitCalc = unitData.calc;

                            const calcItems = unitCalc.items;
                            let priceOld = 0.00;
                            let priceOldEUR = 0.00;
                            let discountTitle = null;

                            calcItems.forEach(item => {
                                // popust za djecu ne ulazi u prikaz discount cijene
                                if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                    priceOld += item.itemTotal;
                                    priceOldEUR += item.itemTotalEUR;
                                }
                                if(item.itemType == 'discount') {
                                    discountTitle = item.itemTitle;
                                    if(item.data && item.data.text) {
                                        discountTitle = item.data.text;
                                    }
                                }
                            });

                            details.calcTotal = unitCalc.total;

                            const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                            const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',');


                            if($btnBooking.attr('href')) {
                                $btnBooking.attr('href',
                                    $btnBooking.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '&dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests +
                                    '&addAllOptionals=' + 1
                                );
                            }
                            let guestsText = unitCalc.guests.split(',', 2);
                            guestsText = guestsText.reduce((sum, num) => sum + +num, 0);
                            $('.calc-message').addClass('d-none');
                            $('.unit-price-container').removeClass('d-none');
                            $('.btn-booking').removeClass('disabled d-none');
                            // $('.btn-request').addClass('d-none');
                            $('.selected-dates').text(functions.formatDate(dateFrom, 'dd.mm.yyyy.') + ' - ' + functions.formatDate(dateTo, 'dd.mm.yyyy.'));
                            $('.nights').text(unitCalc.nights);
                            $('.init-price').addClass('d-none');
                            $('.old-init').addClass('d-none');

                            $('.total').removeClass('d-none').text(total);
                            $('.total-guests').text(guestsText);
                            $('.total-converted-default').addClass('d-none');
                            $('.total-converted').removeClass('d-none');
                            $('.total-converted').text(totalEUR);
                            $('.total-old').removeClass('d-none').text(unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ','));
                            
                            let spDiscount = details.specialDiscounts.filter( (discount) => {
                                let minMaxValid = true;
                                
                                if ((discount['minStay'] && discount['maxStay']))
                                {
                                    if ( ! (unitCalc.nights >= discount['minStay'] && unitCalc.nights <= discount['maxStay'])) minMaxValid = false;
                                }

                                if (discount['dateFrom'] <= details.params.dateFrom && details.params.dateFrom <= discount['dateTo'] && minMaxValid) return true; // b starts in a
                                if (discount['dateFrom'] <= details.params.dateTo   && details.params.dateTo   <= discount['dateTo'] && minMaxValid) return true; // b ends in a
                                if (details.params.dateFrom <  discount['dateFrom'] && discount['dateTo']   <  details.params.dateTo && minMaxValid) return true; // a in b
                                return false;
                            });

                            if (priceOld <= unitCalc.total)
                            {
                                $('.total-old').addClass('d-none');
                                $('.discount-label').addClass('d-none');
                            } 
                            else
                            {
                                $('.discount-label').removeClass('d-none');
                                $('.total-old').parent().removeClass('d-none');
                                $('.discount-percent').text(Math.ceil((1 - (Math.round((unitCalc.total / priceOld)*100) / 100)) * 100))
                            }

                            if (spDiscount.length)
                            {
                                $('.total-old').addClass('d-none');
                                $('.discount-label').addClass('d-none');
                            }
                            
                            $('.btn-select-dates').addClass('d-none');
                            $('.no-calculation').addClass('d-none');
                            $('.calculation').removeClass('d-none');
                            $('.from-label').addClass('d-none');
                            $('.total-label').removeClass('d-none');
                            $('.details-night, .details-guests-num').removeClass('d-none');


                        } else {
                            $('.btn-booking').addClass('disabled d-none');
                            // $('.btn-request').removeClass('d-none');
                            //$('.unit-error-container').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                            $('.calc-message').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                            $('.unit-price-container').addClass('d-none');
                            
                            $('.no-calculation').removeClass('d-none');
                            $('.calculation').addClass('d-none');
                            $('.btn-select-dates').removeClass('d-none');

                            $('.total-label').addClass('d-none');
                            $('.from-label').removeClass('d-none');

                            $('.total-converted').text($('.total-converted').attr('data-from-converted'));
                        }

                        setTimeout(() => {
                            let wh = $(window).outerHeight();
                            $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                            $('.calc-wrapper').css('opacity', 1);
                            $('.calc-wrapper').css('display', 'flex');
                            if (functions.isMobile() && details.focusOnBooking) functions.scrollToElement($('.booking-scroll-hook'), wh);
                        }, 450)
                        

                    });
                }

            }).fail(function (error) {
                console.log(error);
            });
        }

        else {
            $('.btn-booking').addClass('disabled');
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');

            $('.calc-message').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.total-old').toggleClass('d-none', ! $('.total-old').attr('data-minPriceHasDiscount'));
            $('.total-old').text($('.total-old').attr('data-minPriceHasDiscount') ? $('.total-old').attr('data-minPriceOld') : '');

        }
    }
}